import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import plomberieImg from '../../assets/images/plomberie.jpg';
import electriciteImg from '../../assets/images/electricite.jpg';
import menageImg from '../../assets/images/menage.jpg';
import jardinageImg from '../../assets/images/jardinage.jpg';
import webImg from '../../assets/images/web.jpg';
import designImg from '../../assets/images/design.jpg';
import livraisonImg from '../../assets/images/livraison.jpg';
import coiffureImg from '../../assets/images/coiffure.jpg';

const services = [
  { name: 'Plomberie', category: 'artisanat', image: plomberieImg },
  { name: 'Électricité', category: 'artisanat', image: electriciteImg },
  { name: 'Ménage', category: 'domicile', image: menageImg },
  { name: 'Jardinage', category: 'domicile', image: jardinageImg },
  { name: 'Développement web', category: 'numerique', image: webImg },
  { name: 'Design graphique', category: 'numerique', image: designImg },
  { name: 'Livraison express', category: 'transport', image: livraisonImg },
  { name: 'Coiffure', category: 'beaute', image: coiffureImg },
];

const PopularServices = () => {
  return (
    <section className="py-20 bg-[#0a0a0a]">
      <div className="container-custom">
        <h2 className="section-title">
          Nos <span className="text-[#F97316]">services</span> populaires
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Link 
                to={`/book?service=${service.name}&category=${service.category}`} 
                className="card block group overflow-hidden"
              >
                <div className="h-32 bg-[#111111] rounded-xl mb-4 overflow-hidden">
                  <img 
                    src={service.image}
                    alt={service.name}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <h3 className="font-semibold text-white group-hover:text-[#F97316] transition-colors">
                  {service.name}
                </h3>
                <p className="text-sm text-[#AAAAAA] mt-2">
                  Voir les Smarts disponibles →
                </p>
              </Link>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/services" className="btn-primary">
            Voir tous les services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PopularServices;